<template>
  <Modal
    v-model="_value"
    width="500"
    title="查看/修改公共信息"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Form style="display: inline;">
      <FormItem>
        <label>用户【{{comboVehicleInfo.pubUserName}}】修改时间:</label>
        <label>{{formatDate(comboVehicleInfo.pubUpdateDatetime)}}</label>
      </FormItem>
      <FormItem prop="businessState">
        <label style="display: inline-block; width: 60px;">业务状态</label>
        <Select style="display: inline-block; width: 200px;" :disabled="!modify"
                v-model="comboVehicleInfo.pubBusinessState">
          <Option v-for="item in businessState" :value="item.value" :key="item.value">{{item.label}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="pubRemark">
        <label style="display: inline-block; width: 60px;">备注</label>
        <Input style="display: inline-block; width: 400px;" :disabled="!modify" type="textarea"
               v-model="comboVehicleInfo.pubRemark" placeholder="请输入备注">
        </Input>
      </FormItem>
    </Form>
    <Row style="text-align: right;">
      <i-switch v-model="modify" @on-change="modifyChange" size="large">
        <span slot="open">保存</span>
        <span slot="close">修改</span>
      </i-switch>
    </Row>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'combovehiclepubinfodetailmodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null
    },
    data() {
      return {
        modify: false,
        businessState: [
          {label: '待开发', value: 1},
          // {label: '在网', value: 2},
          {label: '继续沟通', value: 3},
          {label: '沟通未果', value: 4},
          // {label: '待安装', value: 5},
          // {label: '待拆机', value: 6},
          // {label: '待收款', value: 7},
          // {label: '服务到期', value: 8},
          // {label: '离网', value: 9},
          // {label: '准备到期', value: 10}
          {label: '同意入网', value: 11}
        ],
        comboVehicleInfo: {
          id: null,
          pubBusinessState:null,
          pubRemark:null
        }
      }
    },
    methods: {
      ...mapActions([
        'ComboVehicleInfoServ_GetDetail',
        'ComboVehicleInfoServ_ModifyPubInfo'
      ]),
      formatDate(val) {
        if (val) {
          let d = new Date(val)
          return d.Format('yyyy年MM月dd日 hh:mm:ss')
        } else {
          return '无'
        }
      },
      modifyChange(status) {
        if (status === false) {
          this.$Modal.confirm({
            title: '确认修改公开信息',
            content: '<p>确认修改公开信息</p>',
            onOk: () => {
                store.dispatch('ComboVehicleInfoServ_ModifyPubInfo', {
                  params: this.comboVehicleInfo
                }).then(() => {
                  this.$Message.success('修改成功')
                  this.$emit('on-success')
                }).catch(err => {
                  this.$Message.error(err)
                  this.$emit('on-fail')
                })
            },
            onCancel: () => {
                store.dispatch('ComboVehicleInfoServ_GetDetail', {
                  params: {id: this._initValue}
                }).then(() => {
                  this.comboVehicleInfo = store.getters.get_ComboVehicleInfo_GetDetailResult
                }).catch(err => {
                  this.$Message.error(err)
                })
            }
          })
        }
      },
      visibleChange(val) {
        if (val) {
          this.modify = false
          this.comboVehicleInfo.pubRemark = null
          this.comboVehicleInfo.pubBusinessState = null
          let comboVehicleInfoId = this._initValue
          if (comboVehicleInfoId) {
            this.comboVehicleInfo.id = comboVehicleInfoId
            if(this.comboVehicleInfo.id){
              store.dispatch('ComboVehicleInfoServ_GetDetail', {
                params: {id: comboVehicleInfoId}
              }).then(() => {
                this.comboVehicleInfo = store.getters.get_ComboVehicleInfo_GetDetailResult
              }).catch(err => {
                this.$Message.error(err)
              })
            }
          }
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
